export default __webpack_public_path__ + "static/media/image-pix.71a364c0.svg";